






















import { Component, Vue, Prop, Mixins, PropSync } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import SalesOrgForm from './SalesOrgForm.vue'

@Component({
  components: {
    SalesOrgForm
  }
})
export default class SalesOrgDialog extends Mixins(BaseVue) {
  @PropSync('open', { default: false })
  public openSync !: boolean
}
